/* istanbul ignore file */

// declarative file
export enum FormRoutes {
  CONTACT = 'contact',
  FRAUD = 'usurpation',
  REACTIVATION = 'reactivation',
  SECURITY = 'securite',
  STANDARD = 'standard',
  TECHNICAL = 'technique',
}
